import { updateMediaDeviceAction } from "../../actions/webrtc";
import { API_UPDATE_RING_MEDIA_DEVICE } from "../../constants/events";
import Emitter from "../../emitter";
import storeRTK from "../../store/storeRTK";
import {
  testCallbackPlayer,
  testcallplayer, testcasePlayer, testchatPlayer,
  testVoicemailPlayer,
} from "../constants";
import { callPlayer } from "./call";
import { callbackPlayer } from "./callback";
import { casePlayer } from "./task";
import { voicemailPlayer } from "./voicemail";

export const registerMediaHandlers = () => {
  Emitter.on(API_UPDATE_RING_MEDIA_DEVICE, (ev) => {
    try {
      if (ev.body?.deviceId) {
        callbackPlayer.setOutputDevice(ev.body.deviceId);
        voicemailPlayer.setOutputDevice(ev.body.deviceId);
        callPlayer.setOutputDevice(ev.body.deviceId);
        casePlayer.setOutputDevice(ev.body.deviceId);
        // chatPlayer.setOutputDevice(ev.body.deviceId);
        testcallplayer.setOutputDevice(ev.body.deviceId);
        testCallbackPlayer.setOutputDevice(ev.body.deviceId);
        testVoicemailPlayer.setOutputDevice(ev.body.deviceId);
        testcasePlayer.setOutputDevice(ev.body.deviceId);
        testchatPlayer.setOutputDevice(ev.body.deviceId);
        storeRTK.dispatch(updateMediaDeviceAction(ev.body?.deviceId));
      }
    } catch (error) {
      console.error(error);
    }
  });
};
